import { useEffect, useRef } from "react";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";
import { useTranslation } from "@/i18n/LanguageContext";

/**
 * Keeps the member's language on their account so it follows them across devices:
 * on sign-in the saved language wins, after that any change is persisted.
 */
export default function LanguageSync() {
  const { user } = useAuth();
  const { lang, setLang } = useTranslation();
  const appliedFor = useRef(null);

  useEffect(() => {
    if (!user) {
      appliedFor.current = null;
      return;
    }
    if (appliedFor.current === user.user_id) return;
    appliedFor.current = user.user_id;
    if (user.language && user.language !== lang) setLang(user.language);
  }, [user, lang, setLang]);

  useEffect(() => {
    if (!user || appliedFor.current !== user.user_id) return;
    if (!lang || lang === user.language) return;
    axios.patch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, { language: lang }).catch(() => {});
  }, [lang, user]);

  return null;
}
